import _ from 'underscore';

export default class Common {
    static getValueFormDictArray(arr, value) {
        if (!arr || value === undefined)
            return '';

        let value_str = String(value);
        var data = _.find(arr, (item) => {
            return item.value !== undefined ? value_str === String(item.value) : false;
        });

        return data ? (data.label !== undefined ? data.label : '') : '';
    }
    /**
     * waitFuncが真を返すまで監視し、真を返すときcallbackを呼ぶ
     */
    static waitForTrue(waitFunc, callback) {
        if(waitFunc()) {
            callback()
            return
        }
        setTimeout(() => {
            waitForTrue(waitFunc, callback)
        }, 500)
    }
}